import { getRequest, postRequest } from "../core/apiRequests";


export const getClients = async ({ query = {}, loadingStatusOff = false, axiosConfig = {} }) => {

  return await getRequest({
    params: ['clients', 0, 'elasticSearchPaginatedList'],
    query,
    loadingStatusOff,
    axiosConfig
  })
};


export const createClient = async ({ data, merchantId, loadingStatusOff = false, axiosConfig = {} }) => {
  const dataObj = {
    client_id: null,
    email: null,
    mobile: null,
    contactPref: null,
    doNotContact: null,
    preferences: [],
    lifeEvents: [],
    address: [],
    ...data,
  };
  const reqObj = {
    params: ['clients', merchantId, 'save'],
    data: dataObj,
    loadingStatusOff,
    axiosConfig
  };

  return await postRequest(reqObj);
};
